import { render, staticRenderFns } from "./GuideSizeSetting.vue?vue&type=template&id=8872899a&scoped=true&"
import script from "./GuideSizeSetting.vue?vue&type=script&lang=ts&"
export * from "./GuideSizeSetting.vue?vue&type=script&lang=ts&"
import style0 from "./GuideSizeSetting.vue?vue&type=style&index=0&id=8872899a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8872899a",
  null
  
)

export default component.exports